import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NgRedux, select } from '@angular-redux/store';
import { Observable, Subscription, combineLatest } from 'rxjs';
import * as Store from '@core/redux/stores';
import {
  ProxyService, AlertService, ConfirmModalService, ModalService, ValidationService,
  OfferService, GtmService, MessageListItem, SelectPickupService, ResolutionService, AccessibilityService, UtilitiesService} from '@core/services';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { IAppState, Actions, ChildRecipeEntity, DspConfig, LoyaltyMode, ModifierResponse, SpecialInstructionResponse, NonExistentSpecialInstructions, NonExistentModifiers, OrderRecipeBasicInfo, isModifierGroupDefaultSelected } from '@core/redux/stores';
import { environment } from '@environments/environment';
import { StartOrderService } from '@features/ordering/services/start-order.service';
import { PickupTimeService } from '@features/ordering/services/pickup-time.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { SelectorService } from '@core/services/selector.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { MenuUtilityService } from '@core/services/menu-utlities.services';
import * as _ from 'lodash-es';
import { ManagePaymentRequest } from '@features/account/models/manage-payment.model';
import { ManagePaymentService } from '@features/account/services/manage-payment.service';
import { CheckoutService } from '@features/ordering/services/checkout.service';
import { AddFavoriteNameService } from '@core/services/add-favorite-name.service';
import { TimePicker, OrderConfigEntity, OrderLoyaltyConfig } from '@features/ordering/models';
import { CustomizationService } from '@features/customization/services';
import { LoggingService } from '@core/services/logging.service';
import { RewardItemService } from '@core/services/reward-item.service';
import { TaxCalculatorService } from '@ordering/services/tax-calculator.service';
import { ButtonEventString, MenuItemType } from '@features/ordering/utilties/enums/order-cart.utility';
import { Guid } from 'ez-guid';
import { CheckTimeUtility } from '@features/ordering/utilties/check-time-utility';
import { GtmExternal, BaseGTMDTO, Ecommerce, Detail, FavoriteGTMDto, VisitNudgeDto, CartGTM } from '@shared/models/configs/gtm.external';
import { BannerNudgeComponent } from '@features/ordering/banner-nudge/banner-nudge.component';
import { trigger, style, transition, animate, state } from '@angular/animations';
import * as moment from 'moment-timezone';
import { PickupPath } from '@app/core/models/payment-service-models.model';
import { FinalCheckoutService } from '@app/features/checkout/services';
import { OrderSummaryItems } from '@app/features/checkout/models';
import { RewardService } from '@app/features/rewards/services/reward.service';
import { Constants } from '@app/core/constants/core.constants';
import { RecipeMap, RecipeType } from '@app/features/customization/models';
@Component({
  selector: 'app-my-order-summary',
  templateUrl: './my-order-summary.component.html',
  styleUrls: ['./my-order-summary.component.less'],
  providers: [AlertService, ManagePaymentService],
  animations: [
    trigger('fade', [
      state('shown', style({ opacity: 1, visibility: 'visible', height: '*' })),
      state('hidden', style({ opacity: 0, visibility: 'hidden', height: 0 })),
      transition('shown => hidden', animate('600ms ease-in')),
      transition('hidden => shown', animate('600ms ease-in')),
    ])
  ]
})
export class MyOrderSummaryComponent implements OnInit, AfterViewInit, OnDestroy {

  @select((appState) => appState.activeOrder) activeOrder: Observable<Store.Order>;
  @select((appState) => appState.locationSelected) locationSelected: Observable<Store.LocationsEntity>;
  @select((appState) => appState.auth.isLoggedIn) isLoggedIn?: Observable<boolean>;
  @ViewChild(BannerNudgeComponent, { static: false })  nudgeBanner: BannerNudgeComponent;
  private subscriptions = new Subscription();
  private orderTotal: number;
  private subTotal: number;
  private tax: number;
  private childRecipe: Store.ChildRecipeEntity = new Store.ChildRecipeEntity;
  private locationsEntity: Store.LocationsEntity;
  private isFavorite: boolean;
  private orderdCollection: Store.Order = new Store.Order;
  private userFavoritesList: Array<Store.Meal>;
  private favName: string;
  private activeMeal: Store.Meal;
  private showAddFavorite: boolean;
  private header;
  private recipes: Store.Recipe;
  public customizations: Store.Customizations;
  private orderSummaryFormGroup: UntypedFormGroup;
  private Ismutiitems: boolean;
  public isUserLoggedIn: boolean;

  private isBreakfastOrdered: boolean;
  private isBreakfastAvailNow = true;
  private isLimitedTimeOfferPopupReq: boolean;
  private limitedParentRecipeArray: Array<number> = [];
  private receipeIds: string;
  private returnUrl: string;
  private singleItemPrice: number;
  private recipeIdForRemove: number;
  private time: string;
  private menuRecipeIdsForLocationValidation: Array<number> = [];
  private drinksRecipeIdsForLocationValidation: Array<number> = [];
  confirmAndPay: Store.ConfirmAndPay;
  public isLoaded: boolean;
  public isLoading: boolean;
  public checkOutLoading: boolean;
  public currentRewards: number;
  protected balance: number;
  protected timepickerList: TimePicker[] = [];
  protected selectedTime: TimePicker = new TimePicker();
  private isBreakFastItemsExist: boolean;
  private timeResult = [];
  private checkFlag: boolean;
  private selectedModifiers: Store.SelectedModifiers[] = [];
  private selectedRecipes: Store.SelectedRecipes[] = [];
  private modifierNames: string[];
  private childRecipeName: string;
  public accToggle = [];
  public breakfastErrorMessage: string;
  public isFavModalActive: boolean;
  public showPopup: boolean;
  public messagetemplate: string;
  private currentRoute: string;
  public isTaxIncluded: boolean;
  public isOfferInCart: boolean;
  public isNudgeBanner: boolean;

  menuImageUrlPrefix: string = environment.IMG_ENDPOINT + '/food';
  locationImageUrlPrefix = '../assets/images/location/';
  today = Date.now();
  latestVisitDate: Date | null;
  private orderConfig: OrderConfigEntity | null;
  private NUDGE_VISIT_CUTOFF_MINUTES = 180;
  private LAST_VISIT_CACHE_CUTOFF_HOURS = 3;
  private MESSAGETYPE_POINTSEARNED = 1;
  private  REMAINING_AMOUNT_REGEX = /\{remainingAmount\}/gi;
  bannerMessageText: string;
  bannerColorHex: string;
  bannerTextColorHex: string;
  nudgeRemainingAmount: number | null;
  private order: Store.Order;
  orderSummaryItems: OrderSummaryItems;
  private taxRate: Store.TaxRatesEntity;
  loyaltyMode: Store.LoyaltyMode;
  constructor(
    private proxy: ProxyService,
    private alertService: AlertService,
    private ngRedux: NgRedux<IAppState>,
    private checkoutService: CheckoutService,
    private confirmModalService: ConfirmModalService,
    private modalService: ModalService,
    private startOrderService: StartOrderService,
    private pickupTimeService: PickupTimeService,
    private selectorService: SelectorService,
    private router: Router,
    private sidenav: MatSidenav,
    public menuUtil: MenuUtilityService,
    private activatedRoute: ActivatedRoute,
    private managePaymentService: ManagePaymentService,
    private addFavoriteNameService: AddFavoriteNameService,
    private cdr: ChangeDetectorRef,
    private customizationService: CustomizationService,
    private rewardItemService: RewardItemService,
    private taxCalulcator: TaxCalculatorService,
    private logger: LoggingService,
    private offerService: OfferService,
    private gtmService: GtmService,
    private selectPickupService: SelectPickupService,
    private checkout: FinalCheckoutService,
    private resolution: ResolutionService,
    private accessibilityService: AccessibilityService,
    private rewards: RewardService) {
    this.isLoading = true;
    this.isUserLoggedIn = false;
    this.checkOutLoading = false;
    this.isTaxIncluded = false;
    this.isNudgeBanner = false;
    this.loyaltyMode = environment.LOYALTY_MODE;
    // All the button events logic will be triggered from here
    this.subscriptions.add(this.confirmModalService.btnEvent.subscribe(
      (data: string) => {
        switch (data) {
          case ButtonEventString.CancelEntireOrder: {
            this.checkFavorite();
            this.sendCancelOrderGTM();
            this.orderdCollection = new Store.Order();
            localStorage.removeItem('offerSelectedData');
            this.offerService.clearOffers(false);
            if(environment.features.deliveryFrontOfFlow) {
              this.selectPickupService.initializePickupService();
              this.ngRedux.dispatch({ type: Actions.CLEARORDER });
              if(this.locationsEntity?.isAutomaticDeliveryLocation) {
                this.ngRedux.dispatch({ type: Actions.CLEARLOATIONSELECTED });
              }
            }
            this.close();
            break;
          }
          case ButtonEventString.SaveFavOrder: {
            this.showFavModal();
            break;
          }
          case ButtonEventString.ScheduleTime: {      
              this.confirmAndPay = new Store.ConfirmAndPay();
              this.ngRedux.dispatch({
                type: Actions.CONFIRMANDPAY,
                data: this.confirmAndPay
              });
              this.checkIfLoggedIn();
            break;
          }
          case ButtonEventString.Removereward: {
            this.removereward();
            break;
          }
          case ButtonEventString.RemoveLimitedTimeItem: {
            this.removeLimitedTimeItems();
            break;
          }
          case ButtonEventString.AddToFavorite: {
            this.addFavoriteNameService.setNavigateFromFav(true);
            this.showFavModal();
            break;
          }
          case ButtonEventString.NotNow: {
            this.checkAndNavigateFromFav();
            break;
          }
          case ButtonEventString.GotIt: {
            this.confirmAndPay = new Store.ConfirmAndPay();
            this.ngRedux.dispatch({
              type: Actions.CONFIRMANDPAY,
              data: this.confirmAndPay
            });
            this.checkIfLoggedIn();
            break;
          }
          case ButtonEventString.RemoveOrderedItem: {
            this.removeOrderedItems(this.recipeIdForRemove);
            break;
          }
          case ButtonEventString.RemoveRecipe: {  
            this.modalService.hideModal();          
            setTimeout(() => {             
              this.clearItems(this.recipeIdForRemove);              
            }, 600);
            break;
          }
          case ButtonEventString.Changelocation: {
            this.close();
            this.changeLocation();
            break;
          }
          case ButtonEventString.Removeloading: {
            this.isLoading = false;
            break;
          }
          case ButtonEventString.Choosenewitem: {
            localStorage.setItem('removeItemFromCart', 'true');
            this.choosenewitem();
            break;
          }
          case ButtonEventString.EditUnavailableModifierRecipe: {            
            const childObj = this.orderdCollection.childRecipes.find(o => o.unAvailableModifierGroupModifierIds.length);
            this.goToCustomization(childObj);
            break;
          } 
          case ButtonEventString.EditModifierGroupWithServeRestrictions: {
            const childObj = this.orderdCollection.childRecipes.find(o => o.modifierGroupsWithServeRestrictions.length);
            this.goToCustomization(childObj);
            break;
          }
          case ButtonEventString.Editdrinks: {
            this.removeMenuItems(MenuItemType.ModifierGroup);
            const childObj = this.orderdCollection.childRecipes.find(o => o.orderItemId === this.drinksRecipeIdsForLocationValidation[0]);
            this.goToCustomization(childObj);
            break;
          }
          case ButtonEventString.RemoveModifierGroups: {
            const objIndex = this.orderdCollection.childRecipes.findIndex(r => r.nonExistentModifierGroups?.length) ;
            this.removeMenuItems(MenuItemType.ModifierGroup, true);
            const childObj = this.orderdCollection.childRecipes[objIndex];
            this.goToCustomization(childObj);
            break;
          }
          case ButtonEventString.RemoveModifiers: {
            const objIndex = this.orderdCollection.childRecipes.findIndex(r => r.nonExistentModifiers?.length) ;
            this.removeMenuItems(MenuItemType.Modifier);
            const childObj = this.orderdCollection.childRecipes[objIndex];
            this.goToCustomization(childObj);
            break;
          } case ButtonEventString.RemoveSpecialInstructions: {
            const objIndex = this.orderdCollection.childRecipes.findIndex(r => r.nonExistentSpecialInstructions?.length) ;
            this.removeMenuItems(MenuItemType.SpecialInstruction);
            const childObj = this.orderdCollection.childRecipes[objIndex];
            this.goToCustomization(childObj);
            break;
          }
          default: {
            break;
          }
        }
      }
    ));
  }
  removeMenuItems(menuItemType: MenuItemType, nonExistent = false) {
    let childObjIndex = null;
    switch (menuItemType) {
      case MenuItemType.ModifierGroup:
        childObjIndex = nonExistent ? this.orderdCollection.childRecipes.findIndex(r => r.nonExistentModifierGroups?.length)
          : this.orderdCollection.childRecipes.findIndex(o => o.orderItemId === this.drinksRecipeIdsForLocationValidation[0]);
        if (nonExistent) {
          this.orderdCollection.childRecipes[childObjIndex].nonExistentModifierGroups = [];
        } else {
          const childRecipe = this.orderdCollection.childRecipes[childObjIndex];
          childRecipe.customizationGroups.forEach(cg => {
            const customizationGroup = cg;
            cg.modifierGroups.forEach(
              mg => {
                if (mg.isSelected && mg.modiferNotAvailable == true) {
                  const defaultModifierGroup = customizationGroup.modifierGroups.find(mg => isModifierGroupDefaultSelected(mg, customizationGroup));
                  if (defaultModifierGroup) {

                    const defaultModifier = defaultModifierGroup.modifiers.find(m => m.isDefaultSelected);
                    if (defaultModifier) {
                      mg.isSelected = false;
                      if(mg?.modifiers?.some(m => m.isSelected)) {
                        mg.modifiers.find(m => m.isSelected).isSelected = false;
                      }
                      defaultModifier.isSelected = true;
                      defaultModifierGroup.isSelected = true;
                    }
                  }
                  mg.modiferNotAvailable = false;
                }
              }
            )
          });
          this.orderdCollection.childRecipes[childObjIndex].isRecipeNotAvailable = undefined;
          this.orderdCollection.childRecipes[childObjIndex].isRecipeNonExistent = false;
        }
        break;
      case MenuItemType.Modifier:
        childObjIndex = this.orderdCollection.childRecipes.findIndex(r => r.nonExistentModifiers?.length);
        this.orderdCollection.childRecipes[childObjIndex].nonExistentModifiers = [];
        break;
      case MenuItemType.SpecialInstruction:
        childObjIndex = this.orderdCollection.childRecipes.findIndex(r => r.nonExistentSpecialInstructions?.length);
        this.orderdCollection.childRecipes[childObjIndex].nonExistentSpecialInstructions = [];
        break;
      default:
        break;
    }
    this.logger.log('this.orderdCollection', this.orderdCollection);
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
  }
  sendCancelOrderGTM() {
    if(this.orderdCollection?.childRecipes?.length > 0) {
      const clearCartPayload = this.gtmService.getGTMCartPayloadFromCart(this.orderdCollection, 'remove_from_cart');
      this.gtmService.sendGenericEvent({ecommerce:null});
      this.gtmService.sendGenericEvent(clearCartPayload);
    }
  }
  private convertDate(date: Date) {
    const dateLocal = new Date(date);
    return new Date(dateLocal.getUTCFullYear(),
      dateLocal.getUTCMonth(),
      dateLocal.getUTCDate(),
      dateLocal.getUTCHours(),
      dateLocal.getUTCMinutes(),
      dateLocal.getUTCSeconds()
    );
  }
  // remove items from the cart if there is no limited time offer
  removeLimitedTimeItems() {
    if (this.orderdCollection.childRecipes.length > 1) {
      const uniqueOrderItemIds = this.limitedParentRecipeArray.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });
      for (let i = 0; i < uniqueOrderItemIds.length; i++) {
        this.removeOrderedItems(uniqueOrderItemIds[i]);
        if (this.menuRecipeIdsForLocationValidation.length > 0) {
          const objIndex1 = this.menuRecipeIdsForLocationValidation.findIndex(k => k === uniqueOrderItemIds[i]);
          this.menuRecipeIdsForLocationValidation.splice(objIndex1, 1);
        }
        if (this.drinksRecipeIdsForLocationValidation.length > 0) {
          const objIndex1 = this.drinksRecipeIdsForLocationValidation.findIndex(k => k === uniqueOrderItemIds[i]);
          this.drinksRecipeIdsForLocationValidation.splice(objIndex1, 1);
        }
      }

    } else {
      setTimeout(() => { this.cancelOrder(); }, 1000);
    }
    this.isLimitedTimeOfferPopupReq = false;
  }
  // This function is for avialability validation
  removeModiferGroups() {
    const childObjIndex = this.orderdCollection.childRecipes.findIndex(o => o.orderItemId === this.drinksRecipeIdsForLocationValidation[0]);
    const childRecipe = this.orderdCollection.childRecipes[childObjIndex];
    childRecipe.customizationGroups.forEach(cg => 
      {
        const customizationGroup = cg;
        cg.modifierGroups.forEach(
        mg =>  {
          if(mg.isSelected && mg.modiferNotAvailable == true) {
             const defaultModifierGroup = customizationGroup.modifierGroups.find(mg => isModifierGroupDefaultSelected(mg));
             if(defaultModifierGroup) {
              const defaultModifier = defaultModifierGroup.modifiers.find(m => m.isDefaultSelected);
              if(defaultModifier) {
                defaultModifier.isSelected = true;
              }
             }
            mg.modiferNotAvailable = false;
          }
        }
      )});
    this.orderdCollection.childRecipes[childObjIndex].isRecipeNotAvailable = undefined;
    this.logger.log('this.orderdCollection', this.orderdCollection);
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
  }

  // To open favorite modal popup to give favorite name
  public showFavModal(): Observable<any> {
    this.isFavModalActive = true;
    this.showModal('app-favname-body', false);
    return null;
  }

  // This is for handling the favorites - saving the favorite, pushing into redux
  public CheckForFavName() {
    // Subscribe to a change
    this.addFavoriteNameService.favNameUpdated.subscribe(
      () => {
        if (this.isFavModalActive === true && this.addFavoriteNameService.getFavName().length > 0) {
          this.isFavModalActive = false;
          this.favName = this.addFavoriteNameService.getFavName();
          // using a settimeout timer to give a moment for the confirm modal to disappear
          setTimeout(() => {
            if (!this.isFavorite) {
              this.saveFavOrder(this.addFavoriteNameService.getFavName());
              // TODO Update reduce and set to favorite
              this.orderdCollection.isFavorite = true;
              this.orderdCollection.favoriteName = this.favName;
            }
          }, 500);
          if (this.addFavoriteNameService.getNavigateFromFav() === true) {
            this.checkAndNavigateFromFav();
          }
        }
      });
  }

  private async getOrderConfig() {
    if (!this.orderConfig) {
      const success = await this.proxy.httpGet(ApiRoutes.ORDER_CONFIG).toPromise();
      this.orderConfig = <OrderConfigEntity>success.body;
    }
  }
  async ngOnInit() {
    sessionStorage.removeItem('childRecipe');
    sessionStorage.removeItem('linkedRecipeBack');
    this.CheckForFavName();
    // Initial value
    this.currentRewards = 0;
    // service call to get rewards 
    try {      
      const rewardSummary = await this.rewards.getRewardSummary();  
      this.currentRewards = rewardSummary.currentRewards ? rewardSummary.currentRewards : 0;
    } catch (error) {
      this.currentRewards = 0;
    } 
    // subscribe for getting location from redux
    this.subscriptions.add(this.locationSelected.subscribe((Succ) => {
      this.locationsEntity = Succ as Store.LocationsEntity;
      this.taxRate = this.taxCalulcator.calculateTaxRate(this.locationsEntity);      
      this.isTaxIncluded = this.taxCalulcator.IsTaxIncluded(this.taxRate.taxRoundingType);
    }, (Err) => {
      this.alertService.error(Err.error.message);
    }));

    // subscribe for getting order details from redux
    this.orderTotal = 0;
    this.subTotal = 0;
    this.tax = 0;
    this.isNudgeBanner = false;
    this.nudgeRemainingAmount = null;
    this.subscriptions.add(combineLatest([this.activeOrder, this.isLoggedIn]).subscribe(
      async ([activeOrder, isUserLoggedIn]) => {
        this.order = _.cloneDeep(activeOrder as Store.Order);
        this.isUserLoggedIn = isUserLoggedIn ? isUserLoggedIn : false;
        const order: Store.Order = activeOrder;
        this.handleActiveOrderChanges(order);
        if (this.isUserLoggedIn && activeOrder) {
          this.latestVisitDate = await this.getLastVisitDate();
          if(this.loyaltyMode == LoyaltyMode.Visits) {
            await this.setNudgeBanner(this.orderdCollection, activeOrder.isNudgeClosed);
          }          
        }
      }, Err => {
        this.alertService.error(Err.error.message);
      }));
    // subscribe for getting queryparams from the URL
    this.subscriptions.add(
      this.activatedRoute.queryParams.subscribe(
        (params: Params) => {
          this.returnUrl = params[Constants.RETURN_URL] as string;
        }
      )
    );
    // If we are returning from the location page to cart, this condition will excute for
    // checking the order availability for changed location
    if (this.returnUrl === 'ordersummary') {
      this.isLoading = true;
      this.checkFlag = false;
      this.checkForOrderAvailability();
    }

    this.header = 'My Order';
    if (!this.isFavorite) {
      this.getFavoritesList();
    }

    // Code to handle global selectors(when we add or delete quantity from cart)
    this.subscriptions.add(this.selectorService.selectObj.subscribe(
      (success) => {
        sessionStorage.setItem('gtmOrderType','cart');
        if (success !== undefined && !this.confirmModalService['trackModalService']['isConfirmModalOpen']) {
          const orderItemId = success.inputId;
          const quantity = success.value;
          if (success.parentCompName === 'orderSummary' && quantity === 1 && success.isQuantityZero === true) {
            if (this.orderdCollection.childRecipes.length > 1) {
              const itemPrice = this.orderdCollection.childRecipes
                .find(c => c.orderItemId === orderItemId).totalPrice;
              this.removeOrderedItem(orderItemId, itemPrice);
            } else {
              this.cancelOrder();
            }
          } else if (success.parentCompName === 'orderSummary') {
            if (this.showAddFavorite && this.isFavorite) {
              this.isFavorite = false;
              this.orderdCollection.isFavorite = false;
              // this.orderdCollection.favoriteName = undefined;
              this.getFavoritesList();
            }
            let recipeObj = this.orderdCollection.childRecipes
              .find(c => c.orderItemId === orderItemId);
            const recipeObjIndex = this.orderdCollection.childRecipes
              .findIndex(c => c.orderItemId === orderItemId);

            // Validation for Reward
            if (!success.isRewardMax &&
              !recipeObj.offerCouponCode) {
              const originalQuantity = recipeObj.quantity;
              recipeObj.quantity = quantity;
              if (recipeObj.quantity > 1 && recipeObj.offerCouponCode) {
                if (this.subTotal > 0 && recipeObj.totalPrice > 0) {
                  this.subTotal -= (recipeObj.totalPrice * recipeObj.quantity);
                }
                if (recipeObj.offerCouponCode && recipeObj.isOfferAdded) {
                  if (recipeObj.isAttachToOffer) {
                    this.orderdCollection.childRecipes.forEach((cr) => {
                      if (cr.offerCouponCode === recipeObj.offerCouponCode) {
                        cr.offerCouponCode = null;
                        cr.isOfferAdded = false;
                        cr.isAttachToOffer = false;
                      }
                    });
                  } else {
                    recipeObj.offerCouponCode = null;
                    recipeObj.isOfferAdded = false;
                  }
                  this.offerService.clearOffers(true);
                }
                recipeObj = this.customizationService.myOrderSummaryCalAndPrice(recipeObj);
                if (success.type === 'increment') {
                  this.calculateTotalPrice('increment', (recipeObj.totalPrice * recipeObj.quantity));                  
                }
                }
                this.gtmService.sendGenericEvent({ ecommerce: null });
                const gtmRecipePayloadOrder = this.gtmService.getGTMCartPayloadFromRecipe(recipeObj);
                if(originalQuantity && originalQuantity < recipeObj.quantity) {
                    gtmRecipePayloadOrder.ecommerce.items[0].quantity = recipeObj.quantity - originalQuantity;
                } else if (originalQuantity && originalQuantity > recipeObj.quantity) {
                  // Decremented - send Remove item from Cart
                  gtmRecipePayloadOrder.ecommerce.items[0].quantity = originalQuantity - recipeObj.quantity;
                  gtmRecipePayloadOrder.add_method = '';
                  gtmRecipePayloadOrder.event = 'remove_from_cart';
                }
              this.calculateOrderTotal();
              this.gtmService.sendGenericEvent(gtmRecipePayloadOrder);
              this.orderdCollection.childRecipes[recipeObjIndex] = recipeObj;
            } else if(this.orderdCollection?.childRecipes?.length > 0 &&
               this.orderdCollection.childRecipes.find(c => c.id === recipeObj.id)?.isOfferAdded && 
               this.orderdCollection.childRecipes.find(c => c.id === recipeObj.id)?.offerCouponCode) {
                 this.insertOfferRecipe(recipeObj);
            } else {
              // creating a copy of Reward item as user wants to add another order item similar to Reward item
              const newRecipeObj = _.cloneDeep(recipeObj);
              newRecipeObj.useReward = false;
              newRecipeObj.quantity = 1;
              // Adding default price of the Reward Item to the new item
              newRecipeObj.totalPrice += newRecipeObj.recipeBasicInfo.price;

              // Generate dynamic orderItemId
              const uid = Math.floor((Math.random() * 10000000000) + 1);
              newRecipeObj.orderItemId = Number(uid);

              this.orderdCollection.childRecipes.push(newRecipeObj);
              // this.calculateOrderTotal();
              // Calculating the updated Total price
              this.calculateTotalPrice('increment', newRecipeObj.totalPrice);
              const gtmRecipePayloadOrder = this.gtmService.getGTMCartPayloadFromRecipe(newRecipeObj);
              this.gtmService.sendGenericEvent({ecommerce:null} as CartGTM);
              this.gtmService.sendGenericEvent(gtmRecipePayloadOrder);
            }
            this.orderSummaryItems = this.checkout.calculateOrderSummaryItems(this.orderdCollection, this.locationsEntity); 
            this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
          }
        } else if (success !== undefined && this.confirmModalService['trackModalService']['isConfirmModalOpen']) {
          this.singleItemPrice = success.value;
          this.recipeIdForRemove = success.inputId;
        }
      }));

    if (this.orderdCollection.childRecipes !== undefined) {
      this.calculateOrderTotal();
    }
    this.getPickUpTimeData();
    this.checkacctoggle(null, undefined);
    this.subscriptions.add(
      this.resolution.width.subscribe(
        (width) => {
          if (width > environment.MAX_MOBILE_WIDTH) {
            this.accessibilityService.setAccessibilityWidgetCSSText(this.accessibilityService.DISPLAYINLINEBLOCKIMPORTANT);
          } else {
            this.accessibilityService.setAccessibilityWidgetCSSText(this.accessibilityService.MYORDERSUMMARYMOBILETOPRIGHTDOCK);

          }
        }
      )
    );
  }
  private insertOfferRecipe(recipeObj) {
    let newRecipeObj = _.cloneDeep(recipeObj);
    newRecipeObj.isOfferAdded = false;
    newRecipeObj.quantity = 1;
    newRecipeObj.offerCouponCode = null;
    newRecipeObj.offerFlag = false;
    const uid = Math.floor((Math.random() * 10000000000) + 1);
    // Insert with a new orderItemId
    newRecipeObj.orderItemId = Number(uid);
    newRecipeObj = this.customizationService.myOrderSummaryCalAndPrice(newRecipeObj);
    this.orderdCollection.childRecipes.push(newRecipeObj);
    this.calculateOrderTotal();
    const gtmRecipePayloadOrder = this.gtmService.getGTMCartPayloadFromRecipe(newRecipeObj);
    this.gtmService.sendGenericEvent({ ecommerce: null });
    this.gtmService.sendGenericEvent(gtmRecipePayloadOrder);
  }
  private async getLastVisitDate() {
    const latestVisitCache = sessionStorage.getItem('lastVisitTime');
    if (latestVisitCache) {
      const visit = JSON.parse(latestVisitCache);
      if (visit && visit.cacheTime) {
        if (visit.visitTime && (Date.now() - +visit.cacheTime < this.LAST_VISIT_CACHE_CUTOFF_HOURS * 1000 * 60 * 60)) {
          this.latestVisitDate = new Date(visit.visitTime);
        }
        return this.latestVisitDate;
      }
    }
    const success = await this.proxy.httpGet(ApiRoutes.ACCOUNT_HISTORY).toPromise();
    const acctHistory = <any>success.body;
    if (acctHistory.activities) {
      const latestVisit = (acctHistory.activities as Array<MessageListItem>).filter(a => a.type === this.MESSAGETYPE_POINTSEARNED)
                                                                            .sort(this.sortDateTime());
      if (latestVisit && latestVisit.length > 0) {
        this.latestVisitDate = this.convertDate(latestVisit[0].dateTime);
      }
      sessionStorage.setItem('lastVisitTime', JSON.stringify({'cacheTime': Date.now()
                                                  , 'visitTime': this.latestVisitDate ? this.latestVisitDate.getTime() : null}) );
    }
    return this.latestVisitDate;
  }

  private handleActiveOrderChanges(Succ: Store.Order) {
    if (Succ) {
      if (Succ.childRecipes) {
        const offerAdded = Succ.childRecipes.find((a) => a.isOfferAdded === true);
        if (offerAdded) {
          this.isOfferInCart = true;
          this.offerService.isOfferInCart = true;
        } else {
          this.isOfferInCart = false;
          this.offerService.isOfferInCart = false;
        }
        if (Succ.isFavorite) {
          this.showAddFavorite = true;
          this.isFavorite = Succ.isFavorite;
          this.favName = Succ.favoriteName;
        }
        const numberOfItems = Succ.childRecipes.length;
        if (numberOfItems > 0) {
          this.orderdCollection = _.cloneDeep(Succ as Store.Order);
          this.orderdCollection.childRecipes.forEach(childRecipe => {
            this.updateNames(childRecipe);
          });
          this.checkItemsNotBeingServed();
          this.offerUpdate();
          this.formControlCreation();
        }
      } else {
        this.isOfferInCart = false;
      }
    } else {
      this.orderdCollection = new Store.Order;
    }
  }
  checkItemsNotBeingServed() {
    this.orderdCollection.childRecipes.forEach((recipe: ChildRecipeEntity) => {
      if(!CheckTimeUtility.isCurrentTimeofDayWithinTimeStamps(recipe?.recipeBasicInfo?.startTime,
         recipe?.recipeBasicInfo?.endTime, this.locationsEntity.timeZone)) {
          recipe.recipeNotAvailableInTimeStampErrorMessage = 
          `${recipe?.recipeBasicInfo?.parentRecipeName ?? recipe?.name} isn’t currently being served. You can order or schedule it
          ${CheckTimeUtility.getFormattedTimeStamps(recipe?.recipeBasicInfo?.startTime, recipe?.recipeBasicInfo?.endTime, this.locationsEntity.timeZone)}`;
         }
         else {
          recipe.recipeNotAvailableInTimeStampErrorMessage = '';
         }
    });
  }
  recipeNotServedAtThisTime(childRecipe: Store.ChildRecipeEntity, showModal = true) {
    this.recipeIdForRemove = childRecipe.orderItemId;
    if (childRecipe?.recipeNotAvailableInTimeStampErrorMessage) {
      const title = `${childRecipe.name} is not currently being cooked`;
      if (showModal) {
        this.confirmModalService.show(
          title,
          childRecipe.recipeNotAvailableInTimeStampErrorMessage,
          '',
          'Schedule Time',
          'Remove Item',
          'Cancel',
          true,
          'scheduleTime',
          'removeRecipe',
          ''
        );
      }
      return childRecipe.recipeNotAvailableInTimeStampErrorMessage;     
    }
  }

  private sortDateTime(): (a: MessageListItem, b: MessageListItem) => number {
    return (a, b) => {
      if (a.dateTime < b.dateTime) {
        return 1;
      } else if (a.dateTime > b.dateTime) {
        return -1;
      }
      return 0;
    };
  }

  private async setNudgeBanner(order: Store.Order, isNudgeClosed: boolean) {
    if (moment().diff(moment(this.latestVisitDate)) >= this.NUDGE_VISIT_CUTOFF_MINUTES * 60 * 1000 || !this.latestVisitDate) {
      // Check order config here to see what ranges do we need to show the nudge
      await this.getOrderConfig();
      const orderLoyalty: Array<OrderLoyaltyConfig> = this.orderConfig.orderLoyalty;
      const orderTotal = order.total;
      if (orderLoyalty && orderLoyalty.length > 0) {
        orderLoyalty.forEach(lc => {
          if (!lc.minAmount) {
            lc.minAmount = 0;
          }
          if (orderTotal >= lc.minAmount && (orderTotal <= lc.maxAmount || !lc.maxAmount)) {
            if (lc.bannerMessageTemplate) {
              const orderTotalForLastGTMPush = sessionStorage.getItem('orderTotalForLastGTMPush');
              // Send Analytics Event - regardless of whether the banner is shown
              if (!orderTotalForLastGTMPush || (orderTotalForLastGTMPush && parseFloat(orderTotalForLastGTMPush) !== orderTotal)) {
                this.gtmService.sendDoubleVisitModalEvent(<VisitNudgeDto>{
                  modal: lc.impressionAnalyticsTag,
                  current_card_value: orderTotal
                });
                sessionStorage.setItem('orderTotalForLastGTMPush', orderTotal.toString());
              }
              if (!isNudgeClosed) {
                this.bannerMessageText = lc.bannerMessageTemplate;
                this.bannerColorHex = lc.bannerColorHex;
                this.bannerTextColorHex = lc.bannerTextColorHex;
                if (lc.bannerMessageTemplate.match(this.REMAINING_AMOUNT_REGEX)) {
                  this.nudgeRemainingAmount = this.taxCalulcator.RoundAwayFromZero(lc.maxAmount - orderTotal + 0.01, 2);
                  this.bannerMessageText =
                    lc.bannerMessageTemplate.replace(this.REMAINING_AMOUNT_REGEX, `$${this.nudgeRemainingAmount.toFixed(2)}`);
                }
                this.isNudgeBanner = true;
              }
            } else {
              this.isNudgeBanner = false;
            }
          }
        });
      }
    }
  }

  // added to validate reward when user does not have reward in account but clicked old reward item
  validateRewardItem() {
    this.confirmModalService.show(
      'Reward already redeemed',
      'You have redeemed the reward since placing this order',
      '',
      'Remove & Continue',
      '',
      'Cancel',
      true,
      'removereward',
      '',
      ''
    );
  }

  // For removing the reward item  from the cart - when user tries to reedem from favorited items prevoiusly
  removereward() {
    const objIndex = this.orderdCollection.childRecipes
      .findIndex(c => c.useReward === true);
    this.orderdCollection.childRecipes.splice(objIndex, 1);
    this.orderdCollection.isRewardAdded = false;
    this.getFavoritesList();
    if (this.showAddFavorite) {
      this.isFavorite = false;
      this.orderdCollection.isFavorite = false;
    }
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });

    if (this.orderdCollection.childRecipes.length === 0) {
      this.close();
    }
  }

  // For  handling the 'details' button(toggling) for each item in the cart
  checkacctoggle(index: number, openStatus: boolean) {
    if (this.orderdCollection.childRecipes) {
      const itemLength = this.orderdCollection.childRecipes.length;
      if (itemLength === 1 && openStatus === undefined) {
        const toggleState = {
          index: 0,
          openStatus: true
        };
        this.accToggle.push(toggleState);
      }
      if (openStatus === undefined) {
        if (itemLength === 1) {
          const toggleState = {
            index: 0,
            openStatus: true
          };
          this.accToggle.push(toggleState);
        } else {
          for (let i = 0; i < itemLength; i++) {
            const toggleState = {
              index: i,
              openStatus: false
            };
            this.accToggle.push(toggleState);
          }
        }
      } else {
        const toggleState = {
          index: index,
          openStatus: openStatus
        };
        this.accToggle.splice(index, 1, toggleState);
      }
      this.logger.log('accToggle', this.accToggle);
    }

  }

  // Checking for, if order availability is there for selected location
  checkForOrderAvailability() {
    this.receipeIds = '';
    this.orderdCollection.childRecipes?.forEach(childrec => {
      this.receipeIds += childrec.id + ',';
      if(childrec?.linkedRecipe) { // Check availability of linked recipe as well
        const childRecipes = this.receipeIds.split(',');
        if(!childRecipes.includes(childrec.linkedRecipe.id.toString())) {
          this.receipeIds += childrec.linkedRecipe.id + ',';
        }
      }
    });
    const recipeMap: RecipeMap[] = this.orderdCollection.childRecipes?.map(r => ({recipeType: r.recipeTypeId, linkedRecipeId: r?.linkedRecipe?.id, recipeId: r.id}));
    const recipeMapCountOfLinkedRecipeTypes = recipeMap.map(r=> r.recipeType).filter((elem, index, self) => index === self.indexOf(elem));
    const isMultipleLinkedRecipeTypes = recipeMapCountOfLinkedRecipeTypes?.length > 1;
    if(isMultipleLinkedRecipeTypes) {
      const apiEndPoints = [];
      const recipeTypeGroup = _.groupBy(recipeMap, 'recipeType');
      Object.keys(recipeTypeGroup).forEach(g => apiEndPoints.push(`${ApiRoutes.LOCATIONS}/${(this?.locationsEntity?.id ?? this.locationsEntity.id?.toString())}/menu/child-recipes?Ids=${recipeTypeGroup[g].map(g => g.linkedRecipeId).join(',')},${recipeTypeGroup[g].map(g => g.recipeId).join(',')}&recipetypeId=${g}`));
      if(apiEndPoints.length) {
        const httpRequests = [];
        apiEndPoints.forEach(api => {
          httpRequests.push(this.proxy.httpGet(api));
        });
        const multiChildResponses: Store.MultiChildRecipeResponse[] = [];
        let successResponse: Store.MultiChildRecipeResponse= {} ;
        successResponse.recipes = [];
        successResponse.ingredients = [];
        this.subscriptions.add(combineLatest(httpRequests).subscribe(async (responses) => {
          responses.forEach(resp => {
            const recipeTypeSent = this.getQueryVariableFromUrl('recipetypeId', (resp as any).url);
            const response = <Store.MultiChildRecipeResponse>(resp as any).body.valueOf(); 
            if(response?.recipes?.length) {
              if(recipeTypeSent) {
                response.recipes.forEach(r => {r.recipeTypeId = Number(recipeTypeSent);});
              }
              successResponse.recipes.push(...response.recipes);
            } 
            if(response?.ingredients?.length) {
              successResponse.ingredients.push(...response.ingredients);
            }
          });
          this.processMultiChildResponse(successResponse);
        }));
      }
    } else {
      this.subscriptions.add(
        this.proxy.httpGet('/locations/' + this.locationsEntity.id + '/menu/child-recipes?Ids=' + this.receipeIds + '&recipetypeid=' + (this.order.childRecipes[0]?.recipeTypeId ?? RecipeType.MediumMeal)).subscribe(
          (success) => {
            const newRecipesResponse = <Store.MultiChildRecipeResponse>success.body.valueOf();
            this.processMultiChildResponse(newRecipesResponse);  
          }
        ));
    }
  }
  private getQueryVariableFromUrl(variable, url) {
    var query = url.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}
  private processMultiChildResponse(newRecipesResponse: Store.MultiChildRecipeResponse) {
    const childRecipeArray = [];
    // Add recipe item into 'childrecipe' array directly from the active order redux object ,
    // if it is not coming from multi service call.
    this.orderdCollection.childRecipes.forEach(childrec => {
      const chilRecipeRoot = newRecipesResponse.recipes.find(c => c.id === childrec.id && c.recipeTypeId == childrec.recipeTypeId);
      if (childrec.linkedRecipe?.id) {
        const linkedRecipeRoot = newRecipesResponse.recipes.find(c => c.id == childrec.linkedRecipe.id);
        if (!linkedRecipeRoot) {
          const activeRecipe = this.orderdCollection.childRecipes.find(c => c.orderItemId === childrec.orderItemId);
          activeRecipe.isRecipeNotAvailable = true;
          childRecipeArray.push(activeRecipe?.linkedRecipe);
        } else if (chilRecipeRoot) {
          chilRecipeRoot.linkedRecipe = linkedRecipeRoot;
        }
      }
      if (!chilRecipeRoot) {
        const activeRecipe = this.orderdCollection.childRecipes.find(c => c.orderItemId === childrec.orderItemId);
        activeRecipe.isRecipeNotAvailable = true;
        childRecipeArray.push(activeRecipe);
      }
    });
    if (newRecipesResponse.recipes.length > 0) {
      newRecipesResponse.recipes.forEach((childrec, index) => {
        childrec.ingredientsList = newRecipesResponse.ingredients;
        const chilRecipeRoot = this.orderdCollection.childRecipes.find(c => c.id === childrec.id && c.recipeTypeId == childrec.recipeTypeId);
        if (chilRecipeRoot) {
          childrec.orderItemId = chilRecipeRoot.orderItemId;
          childrec.isWhatasizeApplied = chilRecipeRoot.isWhatasizeApplied;
          childRecipeArray.push(childrec);
        }
      });
      // handling the duplicate order items in the cart
      const result = this.orderdCollection.childRecipes.filter(function (o1) {
        // filter out (!) items in result2
        return !childRecipeArray.some(function (o2) {
          return o1.orderItemId === o2.orderItemId; // assumes unique id
        });
      });
      result.forEach((chid, ind) => {
        const childjson = JSON.stringify(childRecipeArray);
        const childobj = JSON.parse(childjson);
        const chilRecipeRoot = childobj.find(c => c.id === chid.id);
        chilRecipeRoot.orderItemId = chid.orderItemId;
        childRecipeArray.push(chilRecipeRoot);
      });
      // set offer data
      childRecipeArray.forEach((child, ind) => {
        const childrec = this.orderdCollection.childRecipes.find(c => c.orderItemId === child.orderItemId);
        if (childrec.isOfferAdded) {
          child.isOfferAdded = childrec.isOfferAdded;
          child.isAttachToOffer = childrec.isAttachToOffer;
          child.isOfferDrinkPopupReq = childrec.isOfferDrinkPopupReq;
          child.isOfferSidePopupReq = childrec.isOfferSidePopupReq;
          child.offerCouponCode = childrec.offerCouponCode;
          child.offerFlag = childrec.offerFlag;
        } else if (!childrec.isOfferAdded) {
          child.offerCouponCode = childrec.offerCouponCode ? childrec.offerCouponCode : null;
          child.isOfferAdded = childrec.isOfferAdded;
          child.offerFlag = childrec.offerFlag ? childrec.offerFlag : false;
        }
      });
      this.compareRecipes(childRecipeArray);
    } else {
      this.compareRecipes(childRecipeArray);
    }
  }

  offerUpdate() {
    this.orderdCollection.childRecipes.forEach(childrec => {
      if (childrec) {
        childrec.offerFlag = false;
      }
    });
    const offerindAttachToOffer = this.orderdCollection.childRecipes.findIndex(childrec => {
      if (childrec) {
        return childrec.offerCouponCode && childrec.isAttachToOffer;
      }
    });
    if (offerindAttachToOffer !== -1) {
      this.orderdCollection.childRecipes[offerindAttachToOffer].offerFlag = true;
    } else {
      const offerNoAttach = this.orderdCollection.childRecipes.findIndex(childrec => {
        if (childrec) {
          return childrec.offerCouponCode && (childrec.isOfferAdded || !childrec.isOfferAdded);
        }
      });
      if (offerNoAttach !== -1) {
        this.orderdCollection.childRecipes[offerNoAttach].offerFlag = true;
      } else {
        this.orderdCollection.childRecipes.forEach(childrec => {
          childrec.isOfferAdded = false;
          childrec.offerCouponCode = null;
          childrec.isAttachToOffer = false;
          childrec.offerFlag = false;
        });
      }
    }
  }

  // This is for getting the starting time from the 'getpickuptime' service, for checking breakfast availability time
  getPickUpTimeData() {
    this.isLoading = true;
    this.pickupTimeService.getTime(this.locationsEntity.id, this.subTotal).subscribe(
      (resp) => {
        this.isLoading = false;
        const success = <TimePicker[]>resp.body;
        this.timepickerList = success;
        // const temp = this.pickupTimeService.getAvailablePickupMethods(success);
        if (this.timepickerList.length < 1 || this.timepickerList === undefined) {
          this.locationClosed();
        } else {
          // If ASAP is available, use the next time slot to determine breakfast item warning
          if (this.timepickerList.length > 1 && this.timepickerList[0].isImmediate) {
            this.selectedTime = this.timepickerList[1];
          } else {
            this.selectedTime = this.timepickerList[0];
          }
          this.time = this.selectedTime.displayTimeRange;
          this.timeResult = this.time.split('-');
          this.time = this.timeResult[0].replace(' ', '');
          // this.time = '5:00pm';
        }
      },
      (err) => {
        this.isLoading = false;
        this.alertService.error(err.error.message);
      }
    );
  }

  // For caluclating the order total and displaying in the cart
  calculateOrderTotal() {
    this.subTotal = 0;
    this.orderdCollection.childRecipes.forEach(childrec => {
      if (childrec) {
        if (!childrec.isRecipeNotAvailable) {
          this.subTotal += childrec.totalPrice * childrec.quantity;
        }
      }
    });
    this.orderSummaryItems = this.checkout.calculateOrderSummaryItems(this.orderdCollection, this.locationsEntity);

    if (this.orderdCollection.childRecipes.length > 1) {
      this.Ismutiitems = true;
    } else {
      this.Ismutiitems = false;
    }
    if(this.orderSummaryItems) {
      this.orderTotal = this.orderSummaryItems.orderTotal;
      this.tax = this.orderSummaryItems.tax;
    } else {
      this.tax = this.taxCalulcator.CalculateTax(this.subTotal, this.taxRate.taxRate, this.taxRate.taxRoundingType);
      this.orderTotal = this.subTotal + this.tax;
    }
    this.orderdCollection.tax = this.tax;
    this.orderdCollection.total = this.orderTotal;
  }
  // This function is for form validation - for "who is this for" field
  formControlCreation() {
    this.isLoaded = true;
    this.orderSummaryFormGroup = new UntypedFormGroup({
    });
    for (let i = 0; i < this.orderdCollection.childRecipes.length; i++) {
      const control = new UntypedFormControl(null, [
        ValidationService.custNameValidatorForCart
      ]);
      this.orderSummaryFormGroup.addControl('custname' + i, control);
    }
  }
  // comparing the redux object recipes and new service call recipes(after changing the location),assigning the values appropriatly
  compareRecipes(newRecipesResponse: Store.ChildRecipeEntity[]) {
    this.drinksRecipeIdsForLocationValidation = [];
    this.customizationService.paramSplOpt = null;
    this.orderdCollection.childRecipes.forEach((childrec, index) => {
      let childRecipeRoot = newRecipesResponse.find(c => c.orderItemId === childrec.orderItemId);
      if (!childRecipeRoot.isRecipeNotAvailable) {
        if (!childrec.customizationGroups) {
          childrec = childRecipeRoot;
          childrec.quantity = 1;
        }
        childRecipeRoot.isDrinksNotAvailable = this.returnUrl === 'ordersummary' ? undefined : childrec.isDrinksNotAvailable;
        childRecipeRoot.UnavailableModifierGroups = this.returnUrl === 'ordersummary' ? undefined : childrec.UnavailableModifierGroups;
        childRecipeRoot.nonExistentModifierGroups = childrec.nonExistentModifierGroups;
        childRecipeRoot.nonExistentModifiers = childrec.nonExistentModifiers;
        childRecipeRoot.nonExistentSpecialInstructions = childrec.nonExistentSpecialInstructions;
        childRecipeRoot.customName = childrec.customName;
        childRecipeRoot.hasDrink = childrec.hasDrink;
        childRecipeRoot.hasSide = childrec.hasSide;
        childRecipeRoot.quantity = childrec.quantity;
        childRecipeRoot.selectedScreen = childrec.selectedScreen;
        childRecipeRoot.recipeNotAvailableInTimeStampErrorMessage = childrec.recipeNotAvailableInTimeStampErrorMessage;
        if(childrec.linkedRecipe?.id) {
          childRecipeRoot.linkedRecipe = childrec.linkedRecipe;
          const outerChildLinkedRecipeModifierGroup = childrec?.customizationGroups?.find(cg => cg.modifierGroups?.find(mg => mg.isSelected && mg.linkedRecipeId))
                                                        ?.modifierGroups.find(mg => mg.isSelected && mg.linkedRecipeId && mg?.modifiers?.some(m => m.selectedChildRecipeId));
          if(outerChildLinkedRecipeModifierGroup?.id) {
            const fetchedOuterChildLinkedRecipeModifierGroup = 
                childRecipeRoot.customizationGroups?.find(cg => cg.modifierGroups?.find(mg => mg.id == outerChildLinkedRecipeModifierGroup?.id))
                  ?.modifierGroups?.find(mg => mg.id == outerChildLinkedRecipeModifierGroup?.id);
            if(fetchedOuterChildLinkedRecipeModifierGroup) {
              if(fetchedOuterChildLinkedRecipeModifierGroup?.linkedRecipeId && fetchedOuterChildLinkedRecipeModifierGroup.linkedRecipeId !== childRecipeRoot.linkedRecipe?.id) {
                fetchedOuterChildLinkedRecipeModifierGroup.linkedRecipeId = childRecipeRoot.linkedRecipe?.id;
              }
            }
          }


          childRecipeRoot.linkedRecipe = this.customizationService.myOrderSummaryCalAndPrice(childRecipeRoot.linkedRecipe);
        }
        childRecipeRoot.modifierGroupsWithServeRestrictions = [];
        if (childrec.useReward) {
          childRecipeRoot.useReward = childrec.useReward;
          childRecipeRoot.totalPrice = 0;
          this.customizationService.setReward(true);
          this.rewardItemService.updateCurrentRewardItem(childrec);
        } else if (childrec.offerCouponCode) {
          childRecipeRoot.totalPrice = 0;
        } else {
          childRecipeRoot.totalPrice = childrec.totalPrice;
          this.customizationService.setReward(false);
        }

        childRecipeRoot.customizationGroups.forEach(newCustGroup => {
          if (newCustGroup.hasNoneSelectionGroup) {
            if (newCustGroup.hasNoneSelectionGroup && !newCustGroup.modifierGroups.some(s => s.id === newCustGroup.id)) {
              const date = new Date();
              date.setDate(date.getDate() + 3);
              const modArray: Array<Store.ModifiersEntity> = [];
              newCustGroup.modifierGroups.push({
                id: newCustGroup.id, displayText: newCustGroup.noneSelectionGroupName,
                name: newCustGroup.noneSelectionGroupName,
                sortIndex: undefined, availability: { effective: date.toString() }, modifiers: modArray,
                modiferNotAvailable: undefined,
              });
            }
          }
        });

        childrec.customizationGroups.forEach(
          (custGroup) => {
            if (custGroup.modifierGroups !== undefined) {
              custGroup.modifierGroups.forEach(
                (modifierGroup) => {
                  const selectedModifier = modifierGroup.isSelected ? modifierGroup.isSelected : false;
                  if (selectedModifier) {
                    const selectedcustomizationGroup = newRecipesResponse.find(r => r.orderItemId === childrec.orderItemId).
                      customizationGroups.find(c => c.id === custGroup.id);
                    const selectedmodiferGroup = selectedcustomizationGroup.modifierGroups.find(mg => mg.id === modifierGroup.id);
                    if (selectedmodiferGroup) {
                      if(selectedmodiferGroup.serveStartTime && selectedmodiferGroup.serveEndTime && !CheckTimeUtility.checkIfCurrentTimeIsInBetweenSpans(selectedmodiferGroup.serveStartTime, selectedmodiferGroup.serveEndTime, this.locationsEntity.timeZone)) {
                        childRecipeRoot.modifierGroupsWithServeRestrictions.push(selectedmodiferGroup);
                      }
                      selectedmodiferGroup.isSelected = true;
                      selectedmodiferGroup.selectedModifier = modifierGroup.selectedModifier;

                      const selectedModifiers = newRecipesResponse.find(r => r.orderItemId === childrec.orderItemId)
                        .customizationGroups.find(c => c.id === custGroup.id).modifierGroups.find(mg => mg.id === modifierGroup.id)
                        .modifiers.find(md => md.id === modifierGroup.selectedModifier);
                      if (selectedModifiers) {
                        selectedModifiers.isSelected = true;
                      } else {
                        if(!childRecipeRoot.unAvailableModifierGroupModifierIds) {
                          childRecipeRoot.unAvailableModifierGroupModifierIds = [];                          
                        }
                        if(modifierGroup?.selectedModifier || modifierGroup.name !== custGroup.noneSelectionGroupName) {
                          childRecipeRoot.unAvailableModifierGroupModifierIds.push({'modifierGroupId': modifierGroup.id, 'modifierId': modifierGroup.selectedModifier});
                        } 
                      }

                      if (selectedcustomizationGroup.displayText.includes('Bread')) {
                        const selectedModifierBread = newRecipesResponse.find(r => r.orderItemId === childrec.orderItemId)
                          .customizationGroups.find(c => c.id === custGroup.id).modifierGroups.find(mg => mg.id === modifierGroup.id)
                          .modifiers.find(md => md.id === modifierGroup.selectedModifier);

                        if (selectedModifierBread) {
                          selectedModifierBread.isSelected = true;
                        }

                        const breadModifier = newRecipesResponse.find(r => r.orderItemId === childrec.orderItemId)
                          .customizationGroups.find(c => c.id === custGroup.id).modifierGroups.find(mg => mg.id === modifierGroup.id)
                          .modifiers.find(md => md.id === modifierGroup.selectedModifier);

                        if (breadModifier.specialInstructions) {
                          breadModifier.specialInstructions.forEach(sp => {
                            if (modifierGroup.specialInstructionId) {
                              modifierGroup.specialInstructionId.forEach(msp => {
                                if (msp === sp.id) {
                                  sp.isEnabled = true;
                                  if (!selectedmodiferGroup.specialInstructionId) {
                                    selectedmodiferGroup.specialInstructionId = [];
                                  }
                                  selectedmodiferGroup.specialInstructionId.push(sp.id);
                                }
                              });
                            }
                          });
                        }
                      }
                    } else {
                      modifierGroup.modiferNotAvailable = true;
                      const customizationGroup = newRecipesResponse.find(r => r.orderItemId === childrec.orderItemId)
                        .customizationGroups.find(c => c.id === custGroup.id).modifierGroups.push(modifierGroup);
                      childRecipeRoot.isDrinksNotAvailable = true;
                      this.selectedModifiers.push({ orderItemId: childrec.orderItemId, ModifierName: modifierGroup.displayText });
                      if (!this.drinksRecipeIdsForLocationValidation.find(d => d === childRecipeRoot.orderItemId)) {
                        this.drinksRecipeIdsForLocationValidation.push(childRecipeRoot.orderItemId);
                      }
                      this.updateUnavailableMealItems();
                    }
                  }
                });

            } else {
              if (!this.drinksRecipeIdsForLocationValidation.find(d => d === childRecipeRoot.orderItemId)
                && childRecipeRoot.isDrinksNotAvailable) {
                this.selectedModifiers.push({ orderItemId: childrec.orderItemId, ModifierName: childrec.UnavailableModifierGroups });
                this.drinksRecipeIdsForLocationValidation.push(childRecipeRoot.orderItemId);
              }
            }

          });
        this.customizationService.paramSplOpt = this.isOfferItem(childRecipeRoot) ||
          (childRecipeRoot.isOfferAdded && !childRecipeRoot.isAttachToOffer) ? 'offer' : null;
        childRecipeRoot = <ChildRecipeEntity>this.menuUtil.updateRecipeIncludedInfo(childRecipeRoot);
        childRecipeRoot = this.customizationService.myOrderSummaryCalAndPrice(childRecipeRoot);
      }
      if (childRecipeRoot.isRecipeNotAvailable) {
        this.selectedRecipes.push({ orderItemId: childRecipeRoot.orderItemId, RecipeName: childRecipeRoot.name });
        this.menuRecipeIdsForLocationValidation.push(childRecipeRoot.orderItemId);
      }
      const i = newRecipesResponse.findIndex(x => x.orderItemId === childRecipeRoot.orderItemId);
      newRecipesResponse[i] = childRecipeRoot;
    });
    this.orderdCollection.childRecipes = [];
    this.orderdCollection.childRecipes = newRecipesResponse;
    this.calculateOrderTotal();
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
    this.isLoading = false;
    if (this.checkFlag) {
      this.validateAndNavigate();
    }
  }

  // saving the order as favorite by making a service call
  saveFavOrder(FavName: string) {
    this.isLoading = true;
    this.activeMeal = new Store.Meal();
    this.activeMeal.locationId = this.locationsEntity.id;
    this.activeMeal.pickupType = 0;
    this.activeMeal.isFavorite = true;
    this.activeMeal.favoriteName = FavName; // Adding the favorite name
    this.activeMeal.sort = 0;
    this.activeMeal.createDateTimeUtc = (new Date().toUTCString());

    this.activeMeal.recipes = new Array<Store.Recipe>();
    this.orderdCollection.childRecipes.forEach(childrec => {
      const guid = Guid.create().toString();
      this.recipes = new Store.Recipe();
      this.recipes.clientId = guid;
      // TODO FIX THIS
      this.recipes.categoryId = childrec.categoryId;
      this.recipes.customName = childrec.customName;
      this.recipes.quantity = childrec.quantity;
      this.recipes.recipeId = childrec.id;
      this.recipes.recipeTypeId = childrec.recipeTypeId;
      if (childrec.useReward) {
        this.recipes.useReward = childrec.useReward; // need to work
      } else {
        this.recipes.useReward = false;
      }
      this.recipes.offerId = 0; // need to work
      this.recipes.useWhatASize = true;

      const groupList = this.menuUtil.getCustomizations(childrec);
      if(childrec.linkedRecipe) {
        const linkedRecipeList = this.menuUtil.getCustomizations(childrec.linkedRecipe);
        if(linkedRecipeList.length) {
          if(groupList.some(c => c.linkedRecipeId)) {
            groupList.find(c => c.linkedRecipeId).childCustomizations = linkedRecipeList;
          }
        }          
      } 
      this.recipes.customizations = groupList;    
      this.activeMeal.recipes.push(this.recipes);
    });

    const mealParameter = this.activeMeal;
    this.subscriptions.add(this.proxy.httpPost(ApiRoutes.ADD_FAVORITES, mealParameter).subscribe(
      (success) => {
        this.isLoading = false;
        this.isFavorite = true;
        this.orderdCollection.isFavorite = true;
        this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
        this.addFavoriteNameService.favMealAdded.emit(true);
        // Get the id back from the created record
        this.addFavoriteNameService.setFavId(success.body['id']);
        this.sendFavoriteGtmEvent(GtmExternal.VALUE_STATUS_FAVORITED);

        // Set the session for Favorite
        sessionStorage.setItem('FavoritedLocationId', <any>this.activeMeal.locationId);
      },
      (err) => {
        this.isLoading = false;
        this.alertService.error(err.error.message);
      }
    ));
  }  
  sendFavoriteGtmEvent(status: GtmExternal) {
    const favoriteGtmDto = new FavoriteGTMDto();
    favoriteGtmDto.status = status;
    this.gtmService.sendFavoriteEvent(favoriteGtmDto);
  }

  sendVisitNudgeGTMEvent(status: GtmExternal) {
    const favoriteGtmDto = new FavoriteGTMDto();
    favoriteGtmDto.status = status;
    this.gtmService.sendFavoriteEvent(favoriteGtmDto);
  }

  // To get the count of the favorited items
  getFavoritesList() {
    this.subscriptions.add(this.startOrderService.getFavorites().subscribe(
      (success) => {
        const response = <Array<Store.Meal>>success.body.valueOf();
        this.userFavoritesList = response;
        if (this.userFavoritesList !== undefined && this.userFavoritesList.length > 0) {
          this.showAddFavorite = this.userFavoritesList.length > 11 ? false : true;
        } else {
          this.showAddFavorite = true;
        }
      },
      (err) => {
        this.alertService.error(err.error.message);
      }
    ));
  }

  // this will trigger when we try to remove single order item from the cart
  removeOrderedItem(orderItemId, itemPrice) {
    this.singleItemPrice = itemPrice;
    this.recipeIdForRemove = orderItemId;
    this.confirmModalService.show(
      'Remove Item?',
      '',
      'We want to double check because you can’t undo this action.',
      'Remove Item',
      '',
      'Cancel',
      true,
      'removeOrderedItem'
    );
  }

  // this will trigger when we try to cancel the order
  cancelOrder() {
    setTimeout(() => {
      this.confirmModalService.show(
        'Cancel Your Order?',
        '',
        'Your entire order will be deleted and you’ll be returned to the menu.',
        'Cancel Order',
        '',
        'Keep Order',
        true,
        'cancelEntireOrder'
      );
    }, 100);
  }

  // To caluclate the total tax,price and update the redux
  calculateTotalPrice(eventtype: any, itemPrice: number) {
    sessionStorage.setItem('gtmOrderType','cart');
    if (eventtype === 'increment') {
      this.subTotal += itemPrice;
    } else {
      this.subTotal -= itemPrice;
    }
    if (this.orderdCollection.childRecipes.length > 1) {
      this.Ismutiitems = true;
    } else {
      this.Ismutiitems = false;
    }
    this.orderSummaryItems = this.checkout.calculateOrderSummaryItems(this.orderdCollection, this.locationsEntity); 
    if(this.orderSummaryItems) {
      this.orderTotal = this.orderSummaryItems.orderTotal;
      this.tax = this.orderSummaryItems.tax;
      this.orderdCollection.total = this.orderSummaryItems.orderTotal;
      this.orderdCollection.tax = this.orderSummaryItems.tax;
    } else {
      this.tax = this.taxCalulcator.CalculateTax(this.subTotal, this.taxRate.taxRate, this.taxRate.taxRoundingType);
      this.orderTotal = this.subTotal + this.tax;  
    }
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
  }


  // Confirmation popup before saving the favorite from the cart
  saveFavConfirmation() {
    this.confirmModalService.show(
      '',
      'Would you like to add this order to your favorites?',
      '',
      'Yes, Add to Favorites',
      '',
      'Not Now',
      true,
      'saveFavOrder'
    );
  }

  // Popup to give the favorite name
  showModal(name: string, autoHide: boolean = true) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal(autoHide);
  }

  // for displaying the recipe name
  getRecipeName(name: string, subtitle: string) {
    const subtitleres = name ? name.replace(subtitle, '') : '';
    return name ? name.replace(subtitleres, '') : '';
  }

  // For displaying recipe subtitle
  getRecipeSubtitle(name: string, subtitle: string) {
    return name ? name.replace(subtitle, '') : '';
  }

  // For dispalying the default labels for the stepper
  getDisplayList() {
    const itemCount: Array<number> = [];
    for (let i = 0; i <= 10000; i++) {
      itemCount.push(i);
    }
    return itemCount;
  }
  // Once we click 'Order More' btn from cart page - to navigate to menu landing page
  goToMenuLanding() {
    this.close();
    this.accessibilityService.setAccessibilityWidgetCSSText(this.accessibilityService.DISPLAYINLINEBLOCKIMPORTANT);
    this.router.navigateByUrl('/menu');
  }
  // Once we click 'Redeem Reward' from cart page, this method will trigger and navigate to menu landing  page
  goToRewardsLanding() {
    this.offerService.clearOffers(true);
    this.modalService.setFlyoutBody('app-my-order-summary');
    this.modalService.toggleFlyout();
    this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(() =>
      this.router.navigate(['menu'], { fragment: Constants.REWARDS_ANCHOR }));
  }
  // Click on 'Edit' link from the each item in the cart-navigates to customization
  goToCustomization(orderItem: any) {
    this.close();
    // Remove Non Existent Items on Edit Item Flow
    this.removeNonExistentItems(orderItem);
    sessionStorage.setItem('orderItemId', orderItem.orderItemId);
    const objIndex = this.orderdCollection.childRecipes
      .findIndex(c => c.orderItemId === orderItem.orderItemId);
    if (!orderItem.useReward && !orderItem.isOfferAdded) {
      this.buildCustomizationRoute(orderItem, objIndex);
    } else if (orderItem.isOfferAdded) {
      this.router.navigateByUrl('/customization/order/1/' + orderItem.categoryId + '/' + orderItem.parentRecipeId
        + '/' + orderItem.orderItemId + '/' + objIndex + '/offer');
    } else {
      this.router.navigateByUrl('/customization/order/1/' + orderItem.categoryId + '/' + orderItem.parentRecipeId
        + '/' + orderItem.orderItemId + '/' + objIndex + '/reward');
    }
  }
  private removeNonExistentItems(orderItem) {
    if (orderItem?.nonExistentModifierGroups?.length) {
      this.removeMenuItems(MenuItemType.ModifierGroup, true);
    }
    if (orderItem?.nonExistentModifiers?.length) {
      this.removeMenuItems(MenuItemType.Modifier);
    }
    if (orderItem?.nonExistentSpecialInstructions?.length) {
      this.removeMenuItems(MenuItemType.SpecialInstruction, true);
    }
  }
  // Click on 'Edit' link from the each item in the cart-navigates to customization
  buildCustomizationRoute(orderItem: any, objIndex: number) {
    if (orderItem.categorySlugName !== undefined && orderItem.categoryId !== undefined) {
      this.router.navigateByUrl('/customization/order/1/' + orderItem.categorySlugName + '-' +
        orderItem.categoryId + '/' + orderItem.parentRecipeId
        + '/' + orderItem.slug + '-' + orderItem.orderItemId + '/' + objIndex);
    } else {
      this.router.navigateByUrl('/customization/order/1/' + orderItem.slug + '-' +
        orderItem.id + '/' + orderItem.parentRecipeId
        + '/' + orderItem.slug + '-' + orderItem.orderItemId + '/' + objIndex);
    }
  }
  // this is for validation to 'who is this for' field
  getControlName(i: number, formdt: any) {
    return formdt['custname' + i];
  }

  checkForLimitedTimeItems() {
    this.confirmModalService.show(
      'Limited Time Item Is No Longer Available',
      '',
      'You’ll need to remove this menu item in order to check out.',
      'Remove Limited Time Item',
      '',
      'Cancel',
      true,
      'removeLimitedTimeItem'
    );
  }
  // For removing the items from the cart
  removeOrderedItems(OrderItemId) {
    this.checkFavorite();
    const objIndex = this.orderdCollection.childRecipes.findIndex(c => c.orderItemId === OrderItemId);
    if (this.isOfferInCart) {
      this.checkAndRemoveOffer(OrderItemId);
    }
    const slugName = this.orderdCollection.childRecipes
      .find(c => c.orderItemId === OrderItemId).categorySlugName;
    if (slugName === 'breakfast') {
      this.isBreakfastOrdered = false;
    }

    if (this.orderdCollection.childRecipes[objIndex].useReward === true) {
      this.orderdCollection.isRewardAdded = false;
    }
    const gtmRecipePayloadForRemoval = this.gtmService.getGTMCartPayloadFromRecipe(this.orderdCollection.childRecipes[objIndex], 'remove_from_cart');
    this.gtmService.sendGenericEvent({ecommerce:null});
    this.gtmService.sendGenericEvent(gtmRecipePayloadForRemoval);
    this.orderdCollection.childRecipes.splice(objIndex, 1);
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
    this.calculateTotalPrice('decrement', this.singleItemPrice);
    if (this.orderdCollection.childRecipes.length <= 1) {
      this.Ismutiitems = false;
    }
    if (this.menuRecipeIdsForLocationValidation.length > 0) {
      const objIndex1 = this.menuRecipeIdsForLocationValidation.findIndex(k => k === OrderItemId);
      this.menuRecipeIdsForLocationValidation.splice(objIndex1, 1);
    }
    if (this.drinksRecipeIdsForLocationValidation.length > 0) {
      const objIndex1 = this.drinksRecipeIdsForLocationValidation.findIndex(k => k === OrderItemId);
      this.drinksRecipeIdsForLocationValidation.splice(objIndex1, 1);
    }
  }

  checkAndRemoveOffer(OrderItemId) {
    const objIndex = this.orderdCollection.childRecipes.findIndex(c => c.orderItemId === OrderItemId);
    const obj = this.orderdCollection.childRecipes.find(c => c.orderItemId === OrderItemId);
    const offerItem = this.orderdCollection.childRecipes.find(c => c.offerFlag === true);
    const offerItemIndex = this.orderdCollection.childRecipes.findIndex(c => c.offerFlag === true);
    if (offerItem && offerItem.orderItemId === OrderItemId) {
      this.clearOffers(objIndex);
    } else {
      if (!this.offerService.offerSelectedData) {
        this.offerService.getSelectedOffer(true);
      }
      this.offerService.isBuyOneGetOneFree(this.offerService.offerSelectedData, this.childRecipe.id, this.childRecipe.parentRecipeId);
      if (this.offerService.isBuyOneGetOne || this.offerService.nonBOGOAddedItemRecipeId) {
        if (this.orderdCollection.childRecipes && this.orderdCollection.childRecipes.length > 2) {
          const offerRecipeId = this.orderdCollection.childRecipes[objIndex].id;
          const duplicateReceipes = this.orderdCollection.childRecipes.filter(x => x.id === offerRecipeId);
          if (duplicateReceipes.length > 1) {
            const duplicateRecipe = this.orderdCollection.childRecipes.find(x => x.id === offerRecipeId && x.isOfferAdded !== true);
            if (duplicateRecipe !== undefined) {
              duplicateRecipe.isOfferAdded = this.orderdCollection.childRecipes[objIndex].isOfferAdded;
              duplicateRecipe.offerFlag = this.orderdCollection.childRecipes[objIndex].offerFlag;
              duplicateRecipe.offerCouponCode = this.orderdCollection.childRecipes[objIndex].offerCouponCode;
            }
          } else {
            let nonOfferAndRemainingRecipes: ChildRecipeEntity[] = [];
            nonOfferAndRemainingRecipes = this.orderdCollection.childRecipes.filter(nonoff => {
              return nonoff.orderItemId !== obj.orderItemId && !nonoff.offerFlag;
            });
            if (this.offerService.isBuyOneGetOne && this.retainOffer(nonOfferAndRemainingRecipes, this.offerService.getSelectedOffer(true))) {
              if (this.offerService.offerReceipeId) {
                const duplicateRecipe = this.orderdCollection.childRecipes.find(x => x.id === this.offerService.offerReceipeId);
                if (duplicateRecipe !== undefined) {
                  duplicateRecipe.isOfferAdded = this.orderdCollection.childRecipes[objIndex].isOfferAdded;
                  duplicateRecipe.offerFlag = this.orderdCollection.childRecipes[objIndex].offerFlag;
                  duplicateRecipe.offerCouponCode = this.orderdCollection.childRecipes[objIndex].offerCouponCode;
                }
              } else {
                this.clearOffers(offerItemIndex);
              }
            } else if(this.offerService.nonBOGOAddedItemRecipeId) {
              if(this.orderdCollection.childRecipes[objIndex].isOfferAdded) {
                const duplicateDependentRecipe = this.orderdCollection.childRecipes.filter(x => x.id === this.offerService.nonBOGOAddedItemRecipeId);
                if(duplicateDependentRecipe.length > 1) {
                  const dependentRecipe = duplicateDependentRecipe.find(r => !r.isOfferAdded);
                  dependentRecipe.isOfferAdded = true;
                } else {
                  this.orderdCollection.childRecipes[objIndex].isOfferAdded = false;
                  this.clearOffers(offerItemIndex);
                }
              }
            } else {
              this.clearOffers(offerItemIndex);
            }
          }
        } else {
          this.clearOffers(offerItemIndex);
        }
      }
    }
  }

  retainOffer(nonOfferAndRemainingRecipes: ChildRecipeEntity[], offerSelected: any): boolean {
    let retainOffer = false;
    if (nonOfferAndRemainingRecipes && offerSelected) {
      nonOfferAndRemainingRecipes.forEach(recipe => {
        if (!retainOffer) {
          const validateOfferResults = this.offerService.verifyOfferEligibleForTheChildRecipe(recipe);
          if (validateOfferResults) {
            retainOffer = true;
          }
        }
      });
    }
    return retainOffer;
  }

  clearOffers(objIndex) {
    localStorage.removeItem('offerSelectedData');
    this.offerService.clearOffers(false);
    const offerCouponCode = this.orderdCollection.childRecipes[objIndex].offerCouponCode;
    const offerList = this.orderdCollection.childRecipes.find((off) => {
      return off.offerCouponCode === offerCouponCode && off.isAttachToOffer;
    });
    if (offerList) {
      offerList.isOfferAdded = false;
      offerList.isAttachToOffer = false;
      offerList.offerCouponCode = null;
      offerList.offerFlag = false;
      const childRecipe = this.customizationService.myOrderSummaryCalAndPrice(offerList);
      if(childRecipe?.orderItemId && this.orderdCollection.childRecipes.find(c => c.orderItemId === childRecipe.orderItemId)) {
        this.orderdCollection.childRecipes.find(c => c.orderItemId == childRecipe.orderItemId).totalPrice = childRecipe.totalPrice;
      }
      this.singleItemPrice = offerList.totalPrice;
      this.calculateTotalPrice('increment', offerList.totalPrice);
    }
    this.orderdCollection.childRecipes.forEach(childrec => {
      childrec.isOfferAdded = false;
      childrec.offerCouponCode = null;
      childrec.isAttachToOffer = false;
      childrec.offerFlag = false;
    });
  }

  clearItems(orderItemId) {
    if (this.orderdCollection.childRecipes.length > 1) {
      this.removeOrderedItems(orderItemId);
      this.subTotal = 0;
      if (this.orderdCollection.childRecipes.length == 1 &&
         this.orderdCollection.childRecipes[0].offerCouponCode) {
        this.customizationService.paramSplOpt = this.isOfferItem(this.orderdCollection.childRecipes[0]) ||
        (this.orderdCollection.childRecipes[0].isOfferAdded && !this.orderdCollection.childRecipes[0].isAttachToOffer) ? 'offer' : null;
        this.orderdCollection.childRecipes[0] = <ChildRecipeEntity>this.menuUtil.updateRecipeIncludedInfo(this.orderdCollection.childRecipes[0]);
        this.orderdCollection.childRecipes[0] = this.customizationService.myOrderSummaryCalAndPrice(this.orderdCollection.childRecipes[0]);
      } 
      this.calculateOrderTotal();
    } else {
      this.cancelOrder();
    }
    if (!this.isBreakFastItemsExist) {
      this.isBreakfastOrdered = false;
    }
  }

  checkAndNavigateFromFav() {
    setTimeout(() => {
      this.confirmAndPay = new Store.ConfirmAndPay();
      this.ngRedux.dispatch({ type: Actions.CONFIRMANDPAY, data: this.confirmAndPay });
      this.checkIfLoggedIn();
    }, 1000);
  }
  // Popup will trigger, if any item in cart is not available for the selected timings
  breakfastNotServed() {
    this.confirmModalService.show(
      'Your breakfast items will be available between 11 PM and 11 AM',
      '',
      'You may schedule the order now',
      '',
      'Continue',
      'Cancel',
      true,
      '',
      'scheduleTime',
      'Cancel'
    );
  }

  // Confirmation popup for large order
  takeTimePopup(messageTemplate: string) {
    this.confirmModalService.show(
      messageTemplate,
      '',
      '',
      'Schedule Order',
      '',
      'Edit Order',
      true,
      'gotIt'
    );
  }

  // Popup to show if ordered item is not available for selected location
  menuItemsNotAvailable() {
    this.confirmModalService.show(
      this.childRecipeName + ' menu item(s) is not available at this location. Please select a different location.',
      '',
      '',
      'Choose New Item',
      'Select New Location',
      'Cancel',
      true,
      'choosenewitem',
      'changelocation',
      ''
    );
  }

  // To check if 'online ordering' is available for particular location
  locationClosed() {
    setTimeout(() => {
      this.confirmModalService.show(
        'Online ordering isn\'t available at this location right now.',
        '',
        '',
        'Select New Location',
        'Cancel',
        '',
        true,
        'changelocation',
        'removeloading',
        ''
      );
    }, 1000);

  }
  // Disaplying this popup with all the modifer names, if those modfiers are not availbale for the selected location
  drinksNotAvailable(showModal = true) {
    if(this.modifierNames?.length) {
      const { verb, verb2 } = this.getVerbs(this.modifierNames);
      let items = '';
      const lastItem = this.modifierNames.length - 1;
      if (this.modifierNames.length > 1) {
        this.modifierNames[lastItem] = 'and ' + this.modifierNames[lastItem];       
      } 
      if (this.modifierNames.length === 2) {
        items = this.modifierNames.join(' ');
      } else {
        items = this.modifierNames.join(', ');
      }
      const message = `${items} ${verb} not available at this location. Please select a different location.`;
      if(showModal) {
        this.confirmModalService.show(
          message,
          '',
          '',
          'Edit Order and Continue',
          'Select New Location',
          'Cancel',
          true,
          'editdrinks',
          'changelocation',
          ''
        );
      } else {
        return message;
      }
    }    
  }
  modifiersNotAvailable(childRecipe: ChildRecipeEntity, showModal = true) {
    let modifiers = childRecipe?.unAvailableModifiers;
    if(!(modifiers?.length) && childRecipe?.unAvailableModifierGroupModifierIds?.length) {
      this.proxy.httpGet(`${ApiRoutes.MODIFIER_LOOKUP}?ids=${childRecipe?.unAvailableModifierGroupModifierIds.map(u => u.modifierId)?.join(',')}`).toPromise().then(
        success => {
          const modifierResponse = <ModifierResponse>success.body.valueOf();
          childRecipe.unAvailableModifierGroupModifierIds?.forEach(um => {
            let modifierDetail = modifierResponse.modifiers.find(m => m.id == um.modifierId);
            if(!childRecipe.unAvailableModifiers) {
              childRecipe.unAvailableModifiers = [];
            }
            modifierDetail.modifierGroups = modifierDetail.modifierGroups.filter(mg => mg.id == um.modifierGroupId);
            childRecipe.unAvailableModifiers.push(modifierDetail);
          });
          return this.buildAndPresentModifierUnavailableMessage(childRecipe.unAvailableModifiers, showModal);
        });
    } else {
       return this.buildAndPresentModifierUnavailableMessage(modifiers, showModal);
    }       
  }
  modifierGroupDoesNotexist(childRecipe: ChildRecipeEntity, showModal = true) {
    if(childRecipe?.nonExistentModifierGroups?.length) {
      const { verb, verb2 } = this.getVerbs(childRecipe?.nonExistentModifierGroups);
      // const message = `${childRecipe.nonExistentModifierGroups.map(m => m.name).join(', ')} ${verb} no longer available. Please remove ${verb2} from your order to continue.`;
      const message = `${childRecipe.nonExistentModifierGroups.map(m => `${m.name} ${m.modifierDisplayText}`).join(', ')} ${verb} no longer available. Please remove ${verb2} from your order to continue.`;      
      if(showModal) {
        this.confirmModalService.show(
          message,
          '',
          '',
          'Edit Order and Continue',
          '',
          'Cancel',
          true,
          'removeModifierGroups',
          '',
          ''
        );
      } else {
        return message;
      }
    }    
  }
  private buildAndPresentModifierUnavailableMessage(modifiers: Store.ModifierDetails[], showModal: boolean ) {
    const modifierNames = modifiers.map(m => ` ${m?.modifierGroups[0].displayText} - ${m?.displayText}`);
    if(modifierNames?.length) {
      const { verb } = this.getVerbs(modifierNames);
      let items = '';
      
      const lastItem = modifierNames.length - 1;
      if (modifierNames.length > 1) {
        modifierNames[lastItem] = 'and ' + modifierNames[lastItem];       
      } 
      if (modifierNames.length === 2) {
        items = modifierNames.join(' ');
      } else {
        items = modifierNames.join(', ');
      }
      const message = `${items} ${verb} not available at this location. You may now edit your order and continue or select from locations which carry them.`;
      if(showModal) {
        this.confirmModalService.show(
          message,
          '',
          '',
          'Edit Order and Continue',
          'Select New Location',
          'Cancel',
          true,
          'editUnavailableModifierRecipe',
          'changelocation',
          ''
        );
      } else {
        return message;
      }
    }
  }
  private updateNames(orderItem: Store.ChildRecipeEntity) {
    if(orderItem.isRecipeNotAvailable) {
      this.proxy.httpGet('/menu/recipes?recipeIds=' + orderItem.id).toPromise().then(
        success => {
          const recipe = <OrderRecipeBasicInfo[]>success.body.valueOf();
          if(recipe.length) {
            orderItem.isRecipeNonExistent = !recipe[0].isPublished;
          }
        });
    }
    if(orderItem.nonExistentSpecialInstructions?.length && !orderItem.nonExistentSpecialInstructions?.some(si => si.name)) {
    this.proxy.httpGet(`${ApiRoutes.SPECIAL_INSTRUCTION_LOOKUP}?ids=` + (orderItem.nonExistentSpecialInstructions as NonExistentSpecialInstructions[]).map(si => si.specialInstructionId).join(',')).toPromise().then(
      success => {
        const splInstructions = <SpecialInstructionResponse>success.body.valueOf();
        orderItem.nonExistentSpecialInstructions.forEach(ni => {
          ni.name = splInstructions.specialInstructions.find(si => si.id == ni.specialInstructionId)?.name
        });
      });
    }
    if(orderItem.nonExistentModifiers?.length && !orderItem.nonExistentModifiers?.some(si => si.name) || 
        (orderItem.nonExistentModifierGroups?.some(n => n.modifierId)) || orderItem.unAvailableModifierGroupModifierIds?.length) {
          const nonExistentModifierGroupModifiers = orderItem.nonExistentModifierGroups?.find(n => n.modifierId) ? (orderItem.nonExistentModifierGroups as Store.NonExistentModifierGroups[]).map(si => si.modifierId).join(',') : '';
          const queryStringValue = nonExistentModifierGroupModifiers + ',' + (orderItem.nonExistentModifiers?.length ? (orderItem.nonExistentModifiers as NonExistentModifiers[])?.map(si => si.modifierId).join(',') : '') + (orderItem.unAvailableModifierGroupModifierIds?.length ? orderItem.unAvailableModifierGroupModifierIds.map(u => u.modifierId).join(',') : '');
          this.proxy.httpGet(`${ApiRoutes.MODIFIER_LOOKUP}?ids=${queryStringValue}`).toPromise().then(
          success => {
            const modifiers = <ModifierResponse>success.body.valueOf();
            orderItem.nonExistentModifiers?.forEach(ni => {
              const modifierDetail = modifiers.modifiers.find(si => si.id == ni.modifierId);
              ni.name = modifierDetail?.name
              ni.quantity = modifierDetail?.quantity;
              ni.displayText = modifierDetail?.displayText;
              ni.modifierGroupName = modifierDetail.modifierGroups?.find(mg => mg.id == ni.modifierGroupId)?.name ?? '';
            });

            orderItem.nonExistentModifierGroups?.forEach(nm => {
              const modifierDetail = modifiers.modifiers.find(m => m.id == nm.modifierId);
              nm.modifierDisplayText = modifierDetail?.displayText;
            });
            orderItem.unAvailableModifierGroupModifierIds?.forEach(um => {
              let modifierDetail = modifiers.modifiers.find(m => m.id == um.modifierId);
              if(!orderItem.unAvailableModifiers) {
                orderItem.unAvailableModifiers = [];
              }
              modifierDetail.modifierGroups = modifierDetail.modifierGroups.filter(mg => mg.id == um.modifierGroupId);
              orderItem.unAvailableModifiers.push(modifierDetail);
            })
          });
    }
  }

  modifiersDoNotExist(childRecipe: ChildRecipeEntity, showModal = true) {
    if (childRecipe?.nonExistentModifiers?.length) {
      const { verb, verb2 } = this.getVerbs(childRecipe.nonExistentModifiers);
      // const message = `${childRecipe?.nonExistentModifiers.map(m => m.quantity ? `${m.displayText} (${m.quantity})` : m.name).join(', ')} ${verb} no longer available. Please remove ${verb2} from your order to continue.`;
      const message = `${childRecipe?.nonExistentModifiers.map(m => `${m.modifierGroupName} ${m.displayText}`).join(', ')} ${verb} no longer available. Please remove ${verb2} from your order to continue.`;
      if (showModal) {
        this.confirmModalService.show(
          message,
          '',
          '',
          'Edit Order and Continue',
          '',
          'Cancel',
          true,
          'removeModifiers',
          '',
          ''
        );
      }
      return message;
    }
  }
  private getVerbs(itemArray: any[]) {
    const verb =  itemArray.length > 1 ? 'are' : 'is';
    const verb2 = itemArray.length > 1 ? 'these items' : 'this item';
    return { verb, verb2 };
  }

  // On click of 'Checkout' btn from the cart - this method will be triggered
  CheckoutSubmit() {
    this.isLoading = true;
    setTimeout(() => {
      if (this.locationsEntity.openStatus &&
        this.locationsEntity.openStatus.toLowerCase() === 'closed'
        && (!this.locationsEntity.openInfo
          || this.locationsEntity.openInfo.trim() === '')) {
        this.locationClosed();
        return;
      }
      if (this.currentRewards === 0 && this.orderdCollection.isRewardAdded) {
        this.isLoading = false;
        this.validateRewardItem();
      } else if (this.order.automaticDeliveryLocation) {
        this.pickupTimeService.getDspConfig(this.locationsEntity.id)
        .subscribe(resp => {
          this.isLoading = false;
          const dspConfig = <DspConfig>resp.body;
          if(dspConfig?.maxDeliveryAmount && this.subTotal > dspConfig.maxDeliveryAmount) {
            this.subTotalExceedsMaxDeliveryAmount(dspConfig.maxDeliveryAmount);
            return;
          } else {
            this.proceedToCheckOut();
          }
        }, err => {
          this.isLoading = false;
          this.proceedToCheckOut();
        });
      } else {
        this.proceedToCheckOut();
      }
    }, 2000);
  }
  private subTotalExceedsMaxDeliveryAmount(maxDeliveryAmount: number) {
    this.confirmModalService.show(
      `Delivery is only available for orders under $${maxDeliveryAmount.toString()}`,
      '',
      '',
      'OK, Got It',
      '',
      '',
      true,
      'close'
    );
  }

  private proceedToCheckOut() {
    this.isLoading = true;
    this.checkFlag = true;
    this.menuRecipeIdsForLocationValidation = [];
    this.drinksRecipeIdsForLocationValidation = [];
    this.pickupTimeService.getTime(this.locationsEntity.id, this.subTotal).subscribe(
      (resp) => {
        this.isLoading = false;
        this.timepickerList = <TimePicker[]>resp.body;
        if (this.timepickerList.length < 1 || !this.timepickerList || (this.timepickerList?.length == 1 && !this.timepickerList[0]?.startTimeUtc))  {
          this.locationClosed();
        } else {
          this.checkForOrderAvailability();
        }
      });
  }

  // Calling a service to validate the large order
  async checkOrderSize() {
    const self = this;
    this.showPopup = false;
    if (!this.orderConfig) {
      const success = await this.proxy.httpGet(ApiRoutes.ORDER_CONFIG).toPromise();
      this.orderConfig = <any>success.body;
    }
    const orderSize = this.orderConfig.orderPrepTime;
    self.orderTotal = self.taxCalulcator.RoundAwayFromZero(self.orderTotal, 2);
    if (orderSize && orderSize.length > 0) {
      orderSize.forEach(order => {
        if (order.minAmount !== undefined) {
          if (self.subTotal >= order.minAmount && (self.subTotal <= order.maxAmount ||
            order.maxAmount === undefined || order.maxAmount === null)) {
            if (order.messageTemplate) {
              self.messagetemplate = order.messageTemplate;
              self.messagetemplate = self.messagetemplate.replace('{min_amount}', order.minAmount.toString());
              self.messagetemplate = self.messagetemplate.replace('{prep_time}', order.prepTimeInMinutes.toString());
              self.showPopup = true;
            }
          }
        }
      });
    }
  }
  // Clicking on checkout this function will trigger and validate for all the possible scenarios
  async validateAndNavigate() {
    const recipesNotAvailableAtThistime = this.order.childRecipes.filter(c => c?.recipeNotAvailableInTimeStampErrorMessage) as ChildRecipeEntity[];
    this.calculateOrderTotal();
    this.getPickUpTimeData();
    await this.checkOrderSize();
    this.checkOutLoading = true;
    this.cdr.detectChanges();
    const confirmAndPay = this.checkoutService.confirmAndPay;
    if (this.isLimitedTimeOfferPopupReq) {
      this.checkForLimitedTimeItems();
      this.checkOutLoading = false;
    } else if(this.order.childRecipes.some(cr => cr.modifierGroupsWithServeRestrictions?.length)) {
      setTimeout(() => {
        this.modifierGroupsNotServedAtThisTime(this.order.childRecipes.find(c => c.modifierGroupsWithServeRestrictions?.length), true);
      }, 100);
    } else if(this.order.childRecipes.some(cr => cr.unAvailableModifierGroupModifierIds?.length)) {
      setTimeout(() => {
        this.modifiersNotAvailable(this.order.childRecipes.find(c => c.unAvailableModifierGroupModifierIds?.length), true);
      }, 100);
    }
     else if (this.drinksRecipeIdsForLocationValidation.length > 0) {
      // start - For getting modifier names which are not available and displaying in popup
      this.updateUnavailableMealItems();      
      // end - For getting modifier names which are not available
      setTimeout(() => {
        this.drinksNotAvailable();
        this.checkOutLoading = false;
      }, 2000);
    } else if(this.order.childRecipes.some(c => c?.nonExistentModifierGroups?.length)) {
      setTimeout(() => {
        this.modifierGroupDoesNotexist(this.order.childRecipes.find(c => c.nonExistentModifierGroups?.length), true);
      }, 100);
    } else if(this.order.childRecipes.some(c => c?.nonExistentModifiers?.length)) {
      setTimeout(() => {
        this.modifiersDoNotExist(this.order.childRecipes.find(c => c.nonExistentModifiers?.length), false);
      }, 100);
    } else if(this.order.childRecipes.some(c => c?.nonExistentSpecialInstructions?.length)) {
      setTimeout(() => {
        this.modifierSpecialInstructionsDoNotExist(this.order.childRecipes.find(c => c.nonExistentSpecialInstructions?.length), true);
      }, 100);
    } else if (this.menuRecipeIdsForLocationValidation.length > 0) {
      // start - For getting recipe names which are not available and displaying in popup
      const childObj = this.selectedRecipes.find(o => o.orderItemId === this.menuRecipeIdsForLocationValidation[0]);
      this.childRecipeName = childObj.RecipeName;
      // end - For getting modifer names which are not available
      this.menuItemsNotAvailable();
      this.checkOutLoading = false;
    } else if ((this.isBreakfastOrdered) && !(this.isBreakfastAvailNow)) {
      this.breakfastNotServed();
      this.checkOutLoading = false;
    } else if (this.showPopup) {
      this.takeTimePopup(this.messagetemplate);
      this.checkOutLoading = false;
    } else if(recipesNotAvailableAtThistime?.length) {
      this.recipeNotServedAtThisTime(recipesNotAvailableAtThistime[0]);
      this.checkOutLoading = false;
    } else {
      this.confirmAndPay = new Store.ConfirmAndPay();
      this.ngRedux.dispatch({ type: Actions.CONFIRMANDPAY, data: this.confirmAndPay });
      this.checkIfLoggedIn();
      this.checkOutLoading = false;
    }
    const placeOrder = new BaseGTMDTO();
    const ecommerce = new Ecommerce();
    const detail = new Detail();
    detail.price = this.orderTotal.toString();
    ecommerce.detail = detail;
    placeOrder.ecommerce = ecommerce;
    placeOrder.locationId = this.locationsEntity.unit.toString();
    this.gtmService.sendCheckOutEvent(placeOrder);
    if (this.isFavorite) {
      this.sendFavoriteGtmEvent(GtmExternal.VALUE_STATUS_BEGINCHECKOUT);
    }
    this.cdr.detectChanges();
    if (confirmAndPay !== undefined && confirmAndPay !== null &&
      this.timepickerList !== undefined && this.timepickerList.length >= 1) {
      if (confirmAndPay.isLocationChange) {
        this.router.navigateByUrl('/order-review');
        this.checkOutLoading = false;
        return;
      }
    }
  }
  modifierGroupsNotServedAtThisTime(childRecipe: Store.ChildRecipeEntity, showModal: boolean) {
    if (childRecipe?.modifierGroupsWithServeRestrictions?.length && childRecipe?.modifierGroupsWithServeRestrictions[0]?.serveStartTime && childRecipe?.modifierGroupsWithServeRestrictions[0]?.serveEndTime) {
      const startTime = moment(CheckTimeUtility.tConvert(childRecipe?.modifierGroupsWithServeRestrictions[0]?.serveStartTime), 'HH:mm a', moment.locale()).format('hha');
      const endTime = moment(CheckTimeUtility.tConvert(childRecipe?.modifierGroupsWithServeRestrictions[0]?.serveEndTime), 'HH:mm a', moment.locale()).format('hha');
    

      // const startTime =childRecipe?.modifierGroupsWithServeRestrictions[0].serveStartTime;
      let { verb, verb2 } = this.getVerbs(childRecipe.modifierGroupsWithServeRestrictions);
      if(verb == 'is' && childRecipe.modifierGroupsWithServeRestrictions[0].displayText.endsWith('s')) {
        verb = 'are';
      }     
      const message = `${childRecipe.modifierGroupsWithServeRestrictions.map(m => m.displayText).join(', ')} ${verb}n't currently being served. You can order or schedule between ${startTime} and ${endTime}`;
      if (showModal) {
        this.confirmModalService.show(
          message,
          '',
          '',
          'Schedule Time',
          'Edit Order and Continue',
          'Cancel',
          true,
          'scheduleTime',
          'editModifierGroupWithServeRestrictions',
          ''
        );
      }
      return message;     
    }
  }
  modifierSpecialInstructionsDoNotExist(childRecipe: Store.ChildRecipeEntity, showModal: boolean) {
    if (childRecipe?.nonExistentSpecialInstructions?.length) {
      const { verb, verb2 } = this.getVerbs(childRecipe.nonExistentSpecialInstructions);
      const message = `${childRecipe.nonExistentSpecialInstructions.map(m => m.name).join(', ')} ${verb} no longer available. Please remove ${verb2} from your order to continue.`;
      if (showModal) {
        this.confirmModalService.show(
          message,
          '',
          '',
          'Edit Order and Continue',
          '',
          'Cancel',
          true,
          'removeSpecialInstructions',
          '',
          ''
        );
      }
      return message;     
    }
  }

  private updateUnavailableMealItems() {
    const modiferNames = [];
    this.selectedModifiers.forEach(
      (selectedModifier) => {
        if (this.drinksRecipeIdsForLocationValidation.indexOf(selectedModifier.orderItemId) >= 0) {
          modiferNames.push(selectedModifier.ModifierName);
        }
      });
    const uniqueModiferNames = modiferNames.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });

    this.modifierNames = [];
    uniqueModiferNames.forEach(element => {
      this.modifierNames.push(element);
    });
  }

  // Handling the navigation, based on the loggedin or guest user - after cart page
  checkIfLoggedIn() {
    this.subscriptions.add(
      this.isLoggedIn.subscribe(
        (auth) => {
          this.isUserLoggedIn = auth ? auth : false;
          if (this.timepickerList !== undefined && this.timepickerList.length >= 1) {
            if (this.isUserLoggedIn) {
              this.getCardCount();
            } else {
              this.router.navigateByUrl('/ordering/checkout/customer-info');
            }
          }
        }
      )
    );
  }

  async getCardCount() {

    await this.getGiftCardBalance();

    if (this.balance > 0.00) {
      this.router.navigateByUrl('/order-review');
    } else {
      this.managePaymentService.getCardList().then(
        (clist) => {
          if (!clist.error) {
            const clistlen = <ManagePaymentRequest[]>clist;
            // This is the placeholder for no account balance and no default card
            if (clistlen.length !== undefined && clistlen.length !== 0) {
              this.router.navigateByUrl('/order-review');
            } else {
              this.router.navigateByUrl('/ordering/checkout/payment');
            }
          } else {
            this.router.navigateByUrl('/ordering/checkout/payment');
          }
        },
        (err) => {
          this.alertService.error(err.error.message);
          this.logger.logError(err);
          // do not navigate away when an error is generated or it will never be seen
          // this.router.navigateByUrl('/ordering/checkout-payment');
        }
      );
    }
  }

  async getGiftCardBalance() {
    return await this.proxy.httpGet(ApiRoutes.GIFTCARD).toPromise().then(
      (success) => {
        const successResp = <any>success.body.valueOf();
        this.balance = successResp.balance !== undefined ? successResp.balance : '00.00';
        // return this.balance;
      },
      (err) => {
        this.alertService.error(err?.error?.message);
      }
    );
  }

  choosenewitem() {
    this.close();
    this.router.navigateByUrl('/menu');
  }

  changeLocation() {
    setTimeout(() => {
      if(this?.order?.automaticDeliveryLocation) {
        this.router.navigate(['/order-review'], { queryParams: 
          UtilitiesService.generateQueryParams([Constants.DELIVERY_ADDRESS_CHANGE], [true])});
      } else {
        this.router.navigate(['/locations'], { queryParams: 
          UtilitiesService.generateQueryParams([Constants.RETURN_URL], [Constants.ORDER_SUMMARY])});
      }
    }, 500);

    this.sidenav.close();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    sessionStorage.removeItem('orderTotalForLastGTMPush');
    if(window.innerWidth <= environment.MAX_MOBILE_WIDTH) {
      if(this.router.url.indexOf('/menu') === -1) {
        this.accessibilityService.setAccessibilityWidgetCSSText(this.accessibilityService.DISPLAYINLINEBLOCKIMPORTANT); 
      } else {
        this.accessibilityService.setAccessibilityWidgetCSSText(this.accessibilityService.CHECKOUTMOBILEREPOSITIONWIDGETCSS);
      }
    }
  }

  close() {
    this.sidenav.close();
    this.router.navigate(['/menu']);

  }

  removeLimitedOfferItem(orderItem: any) {
    if (this.orderdCollection.childRecipes.length > 1) {
      const objIndex = this.orderdCollection.childRecipes
        .findIndex(c => c.orderItemId === orderItem.orderItemId);
      this.orderdCollection.childRecipes.splice(objIndex, 1);
      this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
      this.isLimitedTimeOfferPopupReq = false;
      if (this.menuRecipeIdsForLocationValidation.length > 0) {
        const objIndex1 = this.menuRecipeIdsForLocationValidation.findIndex(k => k === orderItem.orderItemId);
        this.menuRecipeIdsForLocationValidation.splice(objIndex1, 1);
      }
      if (this.drinksRecipeIdsForLocationValidation.length > 0) {
        const objIndex1 = this.drinksRecipeIdsForLocationValidation.findIndex(k => k === orderItem.orderItemId);
        this.drinksRecipeIdsForLocationValidation.splice(objIndex1, 1);
      }
    } else {
      this.cancelOrder();
    }
  }


  isRewardItem(orderItem) {
    if (orderItem) {
      return orderItem.useReward ? true : false;
    }
  }

  isOfferItem(orderItem) {
    if (orderItem) {
      if (orderItem.offerFlag) {
        return true;
      } else {
        return false;
      }

    }
  }

  // This is for updating the customer name(who is this for) into redux
  updateCustomerName(orderItemId, value) {
    if (this.orderSummaryFormGroup.status === 'INVALID') {
      return false;
    }
    this.logger.log(orderItemId, value);
    if (value !== '' && value !== undefined) {      
      const childRecipeObj = this.orderdCollection.childRecipes.find(c => c.orderItemId === orderItemId);
      const childRecipeIndex = this.orderdCollection.childRecipes.findIndex(c => c.orderItemId === orderItemId);
      if(value !== childRecipeObj.customName) {
        childRecipeObj.customName = value;
        this.orderdCollection.childRecipes[childRecipeIndex] = childRecipeObj;
        this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
        this.checkFavorite();
      }
    }
  }

  // handling the favorite flags
  checkFavorite() {
    if (this.showAddFavorite && this.isFavorite) {
      this.isFavorite = false;
      this.orderdCollection.isFavorite = false;
      this.getFavoritesList();
    }
  }
  hideNudgeBanner() {
    this.isNudgeBanner = false;
    this.orderdCollection.isNudgeClosed = true;
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.orderdCollection });
  }

  ngAfterViewInit(): void {
    this.gtmService.sendPageName(GtmExternal.VALUE_MYORDER);
    if(this.orderdCollection?.childRecipes?.length > 0) {
      const viewCartPayload = this.gtmService.getGTMCartPayloadFromCart(this.orderdCollection, 'view_item_list');
      this.gtmService.sendGenericEvent(viewCartPayload);
    }  
  }
}
